<template>
  <div class="main">
    <toptab></toptab>
    <div class="mainouter whiteback paddingall">
      <div class="firstinfo">
        <div class="maintitle animated fadeInUp">
          <b v-if="active == 1">多彩公司呈现</b>
          <b v-if="active == 2">行业新闻快报</b>
        </div>
        <div class="maintabs animated fadeInUp">
          <template v-for="(item,index) in tabs">
            <div class="maintab" :key="index" @click="tabClick(item.id)" :class="active==item.id? 'active':''">
              <a href="javascript:void(0);">
                <div style="width:100%">{{item.title}}</div>
              </a>
            </div>
          </template>
        </div>
        <div v-if="active == 1">
          <div class="newslist" v-if="!isSmall">
            <template v-for="(item) in goodslist">
              <newsitem :key="item.id+'one'" :project="item"></newsitem>
            </template>
          </div>
          <div class="newslist" v-if="isSmall">
            <template v-for="(item) in goodslist">
              <newsitemitem :key="item.id+'one'" :project="item"></newsitemitem>
            </template>
          </div>
          <div class="morebtn">
            <a href="javascript:void(0);" v-if="showBtn">
              <img src="../../static/morebtn.png" alt @click="loadMore" />
            </a>
          </div>
        </div>
        <div v-if="active == 2">
          <div class="newslist" v-if="!isSmall">
            <template v-for="(item) in newslist">
              <newsitem :key="item.id+'two'" :project="item"></newsitem>
            </template>
          </div>
          <div class="newslist" v-if="isSmall">
            <template v-for="(item) in newslist">
              <newsitemitem :key="item.id+'two'" :project="item"></newsitemitem>
            </template>
          </div>
          <div class="morebtn">
            <a href="javascript:void(0);" v-if="newsshowBtn">
              <img src="../../static/morebtn.png" alt @click="newsloadMore" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <footeritem></footeritem>
  </div>
</template>

<script>
import toptab from "../components/top-tab-item";
import footeritem from "../components/footer-item";
import newsitem from "../components/news-item";
import newsitemitem from "../components/news-item copy";
import $ from 'jquery';
export default {
  components: {
    toptab,
    footeritem,
    newsitem,
    newsitemitem
  },
  data() {
    return {
      tabs: [
        {
          title: "公司活动",
          id: 1
        }, {
          title: "行业新闻",
          id: 2
        }
      ],
      active: 1,
      goodslist: [],
      current_page: "",
      next_page_url: "",
      last_page: "",
      noMoreClick: false,
      showBtn: true,
      newslist: [],
      newscurrent_page: "",
      newsnext_page_url: "",
      newslast_page: "",
      newsnoMoreClick: false,
      newsshowBtn: true,
      pageact: 0,
      actEnd: false,
      pagenew: 0,
      newEnd: false,
      tabClickk: false,
      newstabClickk: false,
      isSmall: false
    }
  },
  created() {
    this.loadMore();
    this.newsloadMore();
    // this.$nextTick(() => {
    this.$e.$on("smallWindow", () => {
      console.log(this.isSmall);
      this.isSmall = true
    })
    this.$e.$on("bigWindow", () => {
      console.log(this.isSmall);
      this.isSmall = false
    })
    // })
    if (Number(window.innerWidth) <= 1000) {
      this.isSmall = true
    } else {
      this.isSmall = false
    }
    this.$e.$on("newsone", (e) => {
      console.log("eeeeeeee");
      this.active = e
    })
  },
  methods: {
    //tab点击
    tabClick(e) {
      if (this.active == e) {
        return
      }
      // this.goodslist = [];
      // this.current_page = "";
      // this.next_page_url = "";
      // this.last_page = "";
      // this.noMoreClick = false;
      this.active = e

      if (e == 1) {
        if (this.pageact == 0) {
          this.loadMore()
        }

      } else {
        if (this.pagenew == 0) {
          this.newsloadMore()
        }

      }

    },
    /**
     * 数据加载
     */
    loadDef() {
      let url = ""
      if (this.active == 1) {
        this.pageact += 1
        if (this.actEnd) {
          this.showBtn = false
          return
        }
        url = this.$url.companyActivity
        this.$axios.post(url, { page: this.pageact })
          .then(res => {
            console.log(res.data);
            let { error_code, news } = res.data;
            if (error_code == 2001) {
              this.showBtn = false
              this.goodslist = news.data
              this.$nextTick(() => {
                $('.hhh').addClass('animation-scale-up')
              })
              if (news.last_page <= this.pageact) {
                this.actEnd = true
              }
              if (news.next_page_url) {
                // this.next_page_url = news.next_page_url
                this.showBtn = true
              }
            }
            if (error_code == 2007) {
              this.goodslist = []
            }
          })
      } else {
        this.pagenew += 1
        if (this.newEnd) {
          this.newsshowBtn = false
          return
        }
        url = this.$url.industryNews
        this.$axios.post(url, { page: this.pagenew })
          .then(res => {
            console.log(res.data);
            let { error_code, news } = res.data;
            if (error_code == 2001) {
              this.newsshowBtn = false
              this.newslist = news.data
              this.$nextTick(() => {
                $('.hhh').addClass('animation-scale-up')
              })
              if (news.last_page <= this.pagenew) {
                this.newEnd = true
              }
              if (news.next_page_url) {
                // this.newsnext_page_url = news.next_page_url
                this.newsshowBtn = true
              }
            }
            if (error_code == 2007) {
              this.newslist = []
            }
          })
      }

    },
    loadMore() {
      // if(this.tabClickk){
      //   return
      // }
      this.pageact += 1
      if (this.actEnd) {
        this.showBtn = false
        return
      }
      let { current_page, next_page_url, last_page, noMoreClick } = this
      if (noMoreClick) {
        return
      }
      this.noMoreClick = true
      let url = ""
      url = this.$url.companyActivity
      this.$axios.post(url, { page: this.pageact })
        .then(res => {
          console.log(res.data);
          let { error_code, news } = res.data;
          if (error_code == 2001) {
            this.goodslist = this.goodslist.concat(news.data)
            this.$nextTick(() => {
              $('.hhh').removeClass('animation-scale-up')
              $('.hhh').addClass('animation-scale-up')
            })
            if (news.last_page <= this.pageact) {
              this.actEnd = true
            }
            // console.log(this.projectList, news.data);
            if (news.current_page == news.last_page) {
              this.showBtn = false
            } else {
              this.next_page_url = news.next_page_url.match(/\/api.*/)[0]
            }
            // this.$nextTick(() => {
            //   $('.projectitem').addClass('animation-scale-up')
            // })
          }
          this.noMoreClick = false
        })
        .catch(() => {
          this.noMoreClick = false
        })

    },
    newsloadMore() {
      //   if(this.newstabClickk){
      //   return
      // }
      this.pagenew += 1
      if (this.newEnd) {
        this.newsshowBtn = false
        return
      }
      let { newscurrent_page, newsnext_page_url, newslast_page, newsnoMoreClick } = this
      if (newsnoMoreClick) {
        return
      }
      this.newsnoMoreClick = true
      let url = ""
      // if (!newsnext_page_url) {
      url = this.$url.industryNews
      // } else {
      //   url = newsnext_page_url
      // }

      this.$axios.post(url, { page: this.pagenew })
        .then(res => {
          console.log(res.data);
          let { error_code, news } = res.data;
          if (error_code == 2001) {
            this.newslist = this.newslist.concat(news.data)
            this.$nextTick(() => {
              $('.hhh').removeClass('animation-scale-up')
              $('.hhh').addClass('animation-scale-up')
            })
            if (news.last_page <= this.pagenew) {
              this.newEnd = true
            }
            // console.log(this.projectList, news.data);
            if (news.current_page == news.last_page) {
              this.newsshowBtn = false
            } else {
              this.newsnext_page_url = news.next_page_url.match(/\/api.*/)[0]
            }
            // this.$nextTick(() => {
            //   $('.projectitem').addClass('animation-scale-up')
            // })
          }
          this.newsnoMoreClick = false
        })
        .catch(() => {
          this.newsnoMoreClick = false
        })

    },
  }
}
</script>

<style scoped>
@import "../css/animate.min.css";
@import "../css/padding.css";
.main {
  padding-top: 0.67rem;
}

.mainouter {
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.whiteback {
  background-color: #fff;
}
.grayback {
  background-color: #f5f5f5;
}
.firstinfo {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 0.4rem;
}
.maintitle {
  font-size: 0.4rem;
  height: 0.4rem;
  border-left: 4px solid #ff6900;
  line-height: 0.4rem;
  padding-left: 0.1rem;
  margin-bottom: 0.4rem;
}
.maintabs {
  width: 100%;

  padding: 0.4rem;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
.maintab {
  width: 20%;
  min-width: 160px;
  border: 1px solid rgba(136, 136, 136, 1);
  border-radius: 10px;
  line-height: 0.6rem;
  font-size: 0.26rem;
  height: 0.6rem;
  text-align: center;
  margin: 0 0.4rem;
}
.maintab:hover {
  background-color: #ff6900;
  color: #fff;
  border-color: #ff6900;
}
.mainlist {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.mainitem {
  width: 100%;
  max-width: 22%;
  position: relative;
  margin: 0 1.5%;
}
.mainitemimg {
  width: 100%;
}
.mainitemimg img {
  width: 100%;
}
.mainitemtitle {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.2rem;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0.5rem;
}
.mainitem:hover .mainitemtitle {
  color: #fff;
  background-color: #ff6900;
}
.mainitemtop {
  position: absolute;
  top: 0;
  left: 0;
  width: 0.7rem;
  height: 0.7rem;
  text-align: center;
  background-color: #ff6900;
  color: #fff;
  padding-top: 0.1rem;
}
.mainiteminfoone {
  font-size: 0.3rem;
  line-height: 0.3rem;
}
.mainiteminfotwo {
  font-size: 0.1rem;
}
.morebtn {
  display: flex;
  justify-content: center;
}
.morebtn img {
  width: 2rem;
}

.maintab:hover a {
  color: #fff !important;
}

.active {
  background-color: #ff6900;
  color: #fff;
  border-color: #ff6900;
}
.active a {
  color: #fff !important;
}

.newslist {
  display: flex;
  min-height: 4rem;
  flex-wrap: wrap;
}
@media (max-width: 1440px) {
  .firstinfo {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .maintitle {
    font-size: 60px;
    line-height: 60px;
    height: 60px;
  }

  .maintabs {
    padding: 0.4rem 0;
    justify-content: space-between;
  }
  .maintab {
    width: 40%;
    min-width: 160px;
    line-height: 1rem;
    font-size: 0.5rem;
    height: 1rem;
    margin: 0;
  }

  .morebtn img {
    width: 3rem;
  }
}

/* 动画库 */
[class*="animation-"] {
  animation-duration: 0.5s;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
}

.animation-scale-up {
  animation-name: scale-up;
}

@keyframes scale-up {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news.vue